module.exports = __webpack_public_path__ + "media/images/emblems/GW-TG-Muensterlingen-8c2703c7af82439ee3a813a48f141965.svg";